import type { ApiModuleEndpoints } from '../types'

export const dashboardApiEndpoints = {
  revenueSummary: { method: 'GET', path: '/dashboard/revenue-summary', requiresAuth: true },
  revenueReport: { method: 'GET', path: '/dashboard/revenue-report', requiresAuth: true },
  financeReport: { method: 'GET', path: '/dashboard/finance-report', requiresAuth: true },
} as const satisfies ApiModuleEndpoints
